import { Component, OnInit } from '@angular/core';
import { TimesheetReport } from './timesheet-report';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { DatePipe } from '@angular/common';
import { DateServiceService } from 'app/shared/common/helper/dateservice';
import { fuseAnimations } from '@fuse/animations';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { DateConvertor } from 'app/shared/common/helper/dateConvertor';
@Component({
  selector: 'app-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.scss'],
  animations: fuseAnimations
})
export class JobsComponent implements OnInit {

  projectList = [];
  listOfProjects = [];
  twilightEmployees = [];
  userTimesheetResult = [];
  tenantId: string = '';
  employeesList: Array<object> = [];
  query: string = '';
  checkDate: any;
  faceId: string = '';
  checkTime: number = 0;

  // select * from DeviceLogs_${date.getMonth() + 1}_${date.getFullYear()} where LogDate > '${startDate}' and LogDate < '${endDate}' order by UserId desc

  constructor(
    private timesheetReport: TimesheetReport,
    private parseService: ParseService,
    private dateService: DateServiceService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private storageConfiguration: StorageConfiguration,
    private dateConvertor: DateConvertor
  ) {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
  }

  ngOnInit(): any {
    // this.getProjects();
    this.getProjectList();
    this.getEmployeesList();
  }

  getEmployeesList() {
    let queryInstance = this.parseService.instance.Object.extend('Profile');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('tenantId', this.tenantId);
    query.equalTo('isActive', true);
    query.limit(1000);
    query.equalTo('isLongLeave', false);
    query.find().then(result => {
      if (result.length > 0) {
        this.employeesList = [];
        for (let data of result) {
          this.employeesList.push({
            id: data.id,
            name: `${data.get('username')} - ${data.get('esslEmployeeCode')}`,
            faceId: data.get('esslEmployeeCode')
          })
        }
      } else {
        this.employeesList = [];
      }
    });
  }

  timeSheetReportClick(): void {
    this.timesheetReport.getReport(new Date());
  }

  // getProjects() {
  //   this.projectList = [];
  //   let project = this.parseService.instance.Object.extend('Project');
  //   let query = new this.parseService.instance.Query(project);
  //   query.descending('updatedAt');
  //   query.containedIn('projectInfo.currentStatus', ['New', 'In Progress']);
  //   query.limit(100000);
  //   query.find().then(res => {
  //     res.forEach(element => {
  //       this.projectList.push({
  //         projectName: element.get('projectInfo').projectName,
  //         projectId: element.id,
  //         startDate: element.get('projectInfo').projectStartDate,
  //         endDate: element.get('projectInfo').actualCompletionDate
  //       });
  //     });
  //   });
  // }

  // async generateProjectFeeds() {
  //   var query = new this.parseService.instance.Query('ProjectFeeds');
  //   let datepipe = new DatePipe('en-US');
  //   let today = datepipe.transform(new Date(), 'MM/dd/yyyy');
  //   query.equalTo('feedDate', today);
  //   query.limit(100000000000);
  //   let queryResult = await query.find();
  //   if (queryResult.length > 0) {
  //     this.parseService.instance.Object.destroyAll(queryResult);
  //   }

  //   this.projectList.forEach(async projectResult => {
  //     let activityCenterArray = [];
  //     let datePipe = new DatePipe('en-US');
  //     let startDate = datePipe.transform(projectResult.startDate, 'dd MMM yyyy');
  //     let endDate = datePipe.transform(projectResult.endDate, 'dd MMM yyyy')
  //     let message = 'Update on Project ' + projectResult.projectName + ' : Start Date : ' + startDate +
  //       (projectResult.endDate != '' ? (', End Date : ' + endDate) : ', End Date : Not Specified');
  //     activityCenterArray.push(message);
  //     await this.getProjectMembers(projectResult.projectId, projectResult.projectName, activityCenterArray);
  //   });
  // }

  // async getProjectMembers(projectId, projectName, activityCenterArray) {
  //   let membersIds = [];
  //   let projectMember = this.parseService.instance.Object.extend('ProjectMembers');
  //   let projectMemberQuery = new this.parseService.instance.Query(projectMember);
  //   projectMemberQuery.include('project');
  //   projectMemberQuery.include('user');
  //   projectMemberQuery.equalTo('project', {
  //     __type: 'Pointer',
  //     className: 'Project',
  //     objectId: projectId
  //   });
  //   await projectMemberQuery.find().then(async members => {
  //     members.forEach(element => {
  //       membersIds.push(element.get('user').id);
  //     });
  //     let ids = this.uniqBy(membersIds, JSON.stringify);
  //     await this.getTimeSheetDetails(ids, projectId, projectName, activityCenterArray);
  //   });
  // }

  // async getTimeSheetDetails(membersIds, projectId, projectName, activityCenterArray) {
  //   let timeSheet = this.parseService.instance.Object.extend('UserTimeSheet');
  //   let query = new this.parseService.instance.Query(timeSheet);
  //   query.include('user');
  //   query.include('user.profile');
  //   let date = new Date();
  //   let yesterdayDate = date.setDate(date.getDate() - 1);
  //   let dateDifferent = this.dateService.startEndDateByDate(new Date('2019-12-28'));
  //   query.greaterThan('createdAt', dateDifferent[0]);
  //   query.lessThan('createdAt', dateDifferent[1]);
  //   query.containedIn('user', membersIds);
  //   query.limit(10000);
  //   await query.find().then(results => {
  //     let workDetails = [];
  //     membersIds.forEach(id => {
  //       let timeSheets = results.filter(x => x.get('user').id == id);
  //       let workHours = 0;
  //       let userName = '';
  //       if (timeSheets.length > 0) {
  //         timeSheets.forEach(tSheet => {
  //           let userProfile = tSheet.get('user').get('profile');
  //           userName = userProfile.get('firstName') + ' ' + userProfile.get('lastName');
  //           let totalAttendance = tSheet.get('totalAttendance');
  //           let workDatas = totalAttendance.project.filter(a => a.id == projectId);
  //           workDatas.forEach(workData => {
  //             workHours += workData.actualHours;
  //           });
  //         });
  //         if (workHours > 0) {
  //           workDetails.push({ name: userName, id: id, workHours: workHours });
  //         }
  //       }
  //     });
  //     workDetails.forEach(workDetail => {
  //       let message = workDetail.name + ' worked ' + this.secondsToHms(Math.ceil(workDetail.workHours / 1000));
  //       activityCenterArray.push(message);
  //     });
  //     this.getActivities(projectId, activityCenterArray);
  //   });
  // }

  // async getActivities(projectId, activityCenterArray) {
  //   let activitycenter = this.parseService.instance.Object.extend('ActivityCenter');
  //   let query = new this.parseService.instance.Query(activitycenter);
  //   let date = new Date();
  //   let yesterdayDate = date.setDate(date.getDate() - 1);
  //   let dateDifferent = this.dateService.startEndDateByDate(new Date('2019-12-28'));
  //   query.greaterThan('createdAt', dateDifferent[0]);
  //   query.lessThan('createdAt', dateDifferent[1]);
  //   query.equalTo('updatedId', projectId);
  //   query.include('updatedBy');
  //   await query.find().then(activityResult => {
  //     activityResult.forEach(async element => {
  //       let message;
  //       message = element.get('updatedBy').get('firstName') + ' ' + element.get('message') + ' ' + name;
  //       activityCenterArray.push(message);
  //     });
  //     let emptyMessage = 'No activities';
  //     if (activityCenterArray.length == 1) {
  //       activityCenterArray.push(emptyMessage)
  //     }
  //     this.saveFeeds(projectId, activityCenterArray);
  //   });
  // }

  // async saveFeeds(projectId, activityCenterArray) {
  //   let message = activityCenterArray.join(". ").replace(/(\r\n|\n|\r)/gm, "");
  //   let datePipe = new DatePipe('en-US');
  //   let todayDate = datePipe.transform(new Date(), 'MM/dd/yyyy');
  //   let ProjectFeedClass = this.parseService.instance.Object.extend('ProjectFeeds');
  //   var projectFeeds = new ProjectFeedClass();
  //   projectFeeds.set('feedDate', todayDate);
  //   projectFeeds.set('message', message);
  //   projectFeeds.set('projectId', {
  //     __type: 'Pointer',
  //     className: 'Project',
  //     objectId: projectId
  //   });
  //   projectFeeds.save();
  //   this.toastr.success('Project Feed Generated!!!');
  // }


  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    var sDisplay = (s <= 9 ? '0' : '') + s;
    return hDisplay + ' Hours ' + mDisplay + ' Minutes ' + sDisplay + ' Seconds ';
  }

  uniqBy(a, key) {
    var index = [];
    return a.filter(function (item) {
      var k = key(item);
      return index.indexOf(k) >= 0 ? false : index.push(k);
    });
  }

  getProjectList() {
    this.listOfProjects = [];
    let project = this.parseService.instance.Object.extend('Project');
    let query = new this.parseService.instance.Query(project);
    query.descending('updatedAt');
    query.limit(100000);
    query.find().then(res => {
      this.listOfProjects = res;
    });
  }

  updateProjectStatus() {
    this.toastr.success('Project status updation started');
    this.listOfProjects.forEach(async element => {
      await this.projectMembers(element);
    });
    // this.toastr.success('Project status updated successfully');
  }

  async projectMembers(project) {
    let assignedResourcesId = [];
    let projectMember = this.parseService.instance.Object.extend('ProjectMembers');
    let projectMemberQuery = new this.parseService.instance.Query(projectMember);
    projectMemberQuery.include('project');
    projectMemberQuery.include('project.client');
    projectMemberQuery.include('user');
    projectMemberQuery.include('user.profile');
    projectMemberQuery.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: project.id });
    projectMemberQuery.limit(10000);
    await projectMemberQuery.find().then(results => {
      results.forEach(element => {
        assignedResourcesId.push(element.get('user').id);
      });
      this.getFixedProjectUserTimesheet(assignedResourcesId, project);
    });
  }

  async getFixedProjectUserTimesheet(assignedResources, projectDetails) {

    let projectType = projectDetails.get('projectInfo').projectType ? projectDetails.get('projectInfo').projectType : projectDetails.get('projectInfo').addOnType;
    if (projectType == 'Dedicated') {
      let projectActualCompletionDate = projectDetails.get('projectInfo').actualCompletionDate;
      let projectExtendedCompletionDate = projectDetails.get('projectInfo').extendedCompletionDate;
      if (projectActualCompletionDate != '' || projectExtendedCompletionDate != '') {
        if ((new Date(projectActualCompletionDate) < new Date()) || (new Date(projectExtendedCompletionDate) < new Date())) {
          projectDetails.set('schedulerStatus', 'Dedicated Non-Billable');
        }
        else {
          projectDetails.set('schedulerStatus', 'Dedicated Billable');
        }
      }
      if (projectActualCompletionDate == '' && projectExtendedCompletionDate == '') {
        projectDetails.set('schedulerStatus', 'Dedicated Billable');
      }
    }
    else if (projectType == 'Fixed') {
      await this.getTimesheet(projectDetails, assignedResources).then(result => {
        let totalWorkHours = (result / 1000) / 3600;
        let totalProjectHours = this.getHoursCount(projectDetails.get('resourceDetails').details);
        if (totalProjectHours < totalWorkHours) {
          projectDetails.set('schedulerStatus', 'Fixed Non-Billable');
        }
        else {
          projectDetails.set('schedulerStatus', 'Fixed Billable');
        }
      });
    }
    else if (projectType === 'Task') {
      projectDetails.set('schedulerStatus', 'Fixed Non-Billable');
    }
    else if (projectType == 'Support') {
      let projectActualCompletionDate = projectDetails.get('projectInfo').actualCompletionDate;
      let projectExtendedCompletionDate = projectDetails.get('projectInfo').extendedCompletionDate;
      if ((new Date(projectActualCompletionDate) < new Date()) || (new Date(projectExtendedCompletionDate) < new Date())) {
        projectDetails.set('schedulerStatus', 'Dedicated Non-Billable');
      }
      else {
        projectDetails.set('schedulerStatus', 'Dedicated Billable');
      }
    }

    projectDetails.save();
  }

  async getTimesheet(projectDetails, assignedResources) {
    let totalWorkHours = 0;
    let userClass = this.parseService.instance.Object.extend('UserTimeSheet');
    let query = new this.parseService.instance.Query(userClass);
    query.containedIn('user', assignedResources);
    query.limit(1000000);
    await query.find().then(results => {
      let timeSheets = results;
      let projectTimesheet = JSON.parse(JSON.stringify(timeSheets));
      projectTimesheet.forEach(element => {
        element.totalAttendance.project.forEach(element => {
          if (projectDetails.id == element.id) {
            totalWorkHours += element.actualHours;
          }
        });
      });
    });
    return totalWorkHours;
  }

  getHoursCount(projectHours) {
    let total = 0;
    projectHours.forEach(element => {
      total += element.hours;
    });
    return total;
  }

  async createResourceStatus() {
    this.spinner.show();
    var deleteOldRecords = new this.parseService.instance.Query('ResourceStatus');
    let dateDifferents = this.dateService.startEndDateByDate(new Date());
    deleteOldRecords.greaterThan('createdAt', dateDifferents[0]);
    deleteOldRecords.lessThan('createdAt', dateDifferents[1]);
    deleteOldRecords.limit(100000000000);
    let queryResult = await deleteOldRecords.find();
    if (queryResult.length > 0) {
      this.parseService.instance.Object.destroyAll(queryResult);
    }

    this.userTimesheetResult = [];
    let timeSheet = this.parseService.instance.Object.extend('UserTimeSheet');
    let query = new this.parseService.instance.Query(timeSheet);
    query.include('user');
    query.include('user.profile');
    let date = new Date();
    let yesterdayDate;
    yesterdayDate = date.setDate(date.getDate() - 1);

    var d = new Date();
    var getTot = daysInMonth(d.getMonth(), d.getFullYear()); //Get total days in a month
    var sun = new Array();   //Declaring array for inserting Sundays
    for (var i = 1; i <= getTot; i++) {    //looping through days in month
      var newDate = new Date(d.getFullYear(), d.getMonth(), i)
      if (newDate.getDay() == 0) {   //if Sunday
        sun.push(i);
      }
    }
    function daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    }

    if ((new Date(yesterdayDate).getDate() == sun[0]) || (new Date(yesterdayDate).getDate() == sun[2]) || (new Date(yesterdayDate).getDate() == sun[4])) {
      yesterdayDate = date.setDate(date.getDate() - 3);
    }
    if ((new Date(yesterdayDate).getDate() == sun[1]) || (new Date(yesterdayDate).getDate() == sun[3]) || (new Date(yesterdayDate).getDate() == sun[5])) {
      yesterdayDate = date.setDate(date.getDate() - 2);
    }
    let dateDifferent = this.dateService.startEndDateByDate(new Date(yesterdayDate));
    // let dateDifferent = this.dateService.startEndDateByDate(new Date('2020-02-14'));
    query.greaterThan('createdAt', dateDifferent[0]);
    query.lessThan('createdAt', dateDifferent[1]);
    query.limit(10000);
    await query.find().then(results => {
      this.userTimesheetResult = this.uniqBy(results, JSON.stringify);
      this.notLoggedEmployees();
      this.userTimesheetResult.forEach(element => {
        let totalAttendance = element.get('totalAttendance').project;
        this.getProjectStatus(element, totalAttendance);
      });
      this.spinner.hide();
      this.toastr.success('Resource status generated successfully');
    });
  }

  getProjectStatus(userTimesheet, totalAttendance) {
    let dedicatedBillableWorkHours = 0;
    let fixedBillableWorkHours = 0;
    let nonBillableWorkHours = 0;
    let projectId = [];
    totalAttendance.forEach(async element => {
      let schedulerStatus = '';
      let project = new this.parseService.instance.Object('Project');
      project.id = element.id;
      projectId.push(element.id);
      schedulerStatus = project.get('schedulerStatus');

      if (schedulerStatus != undefined) {
        if (schedulerStatus == 'Dedicated Billable') {
          dedicatedBillableWorkHours += (element.actualHours / 1000) / 3600;
        }
        else if (schedulerStatus == 'Dedicated Non-Billable') {
          nonBillableWorkHours += (element.actualHours / 1000) / 3600;
        }
        else if (schedulerStatus == 'Fixed Billable') {
          fixedBillableWorkHours += (element.actualHours / 1000) / 3600;
        }
        else if (schedulerStatus == 'Fixed Non-Billable') {
          nonBillableWorkHours += (element.actualHours / 1000) / 3600;
        }
      }
    });
    let totalWorkHours = dedicatedBillableWorkHours + nonBillableWorkHours + fixedBillableWorkHours;
    do {
      if (nonBillableWorkHours > 6) {
        let resourceClass = this.parseService.instance.Object.extend('ResourceStatus');
        var resourceDetails = new resourceClass();
        resourceDetails.set('resourceStatus', 'Non-Billable');
        resourceDetails.set('user', { __type: 'Pointer', className: '_User', objectId: userTimesheet.get('user').id });
        resourceDetails.set('projectId', projectId);
        break;
      }
      if (totalWorkHours < 3) {
        let resourceClass = this.parseService.instance.Object.extend('ResourceStatus');
        var resourceDetails = new resourceClass();
        resourceDetails.set('resourceStatus', 'Non-Billable');
        resourceDetails.set('user', { __type: 'Pointer', className: '_User', objectId: userTimesheet.get('user').id });
        resourceDetails.set('projectId', projectId);
        break;
      }
      if (dedicatedBillableWorkHours > fixedBillableWorkHours) {
        let resourceClass = this.parseService.instance.Object.extend('ResourceStatus');
        var resourceDetails = new resourceClass();
        resourceDetails.set('resourceStatus', 'Dedicated Billable');
        resourceDetails.set('user', { __type: 'Pointer', className: '_User', objectId: userTimesheet.get('user').id });
        resourceDetails.set('projectId', projectId);
        break;
      }
      if (dedicatedBillableWorkHours < fixedBillableWorkHours) {
        let resourceClass = this.parseService.instance.Object.extend('ResourceStatus');
        var resourceDetails = new resourceClass();
        resourceDetails.set('resourceStatus', 'Fixed Billable');
        resourceDetails.set('user', { __type: 'Pointer', className: '_User', objectId: userTimesheet.get('user').id });
        resourceDetails.set('projectId', projectId);
        break;
      }

    } while (0);
    if (resourceDetails != undefined) {
      resourceDetails.save();
    }

  }

  async notLoggedEmployees() {
    this.twilightEmployees = [];
    let profileClass = this.parseService.instance.Object.extend('User');
    let query = new this.parseService.instance.Query(profileClass);
    query.include('profile');
    query.limit(10000000);
    await query.find().then(async results => {
      let userResult = results;
      this.twilightEmployees = userResult.filter(x => (x.get('profile').get('isActive') == true) && (x.get('profile').get('isLongLeave') == false));
      this.userTimesheetResult.forEach(element => {
        let userId = element.get('user').id
        let find = this.twilightEmployees.findIndex(x => x.id == userId);
        this.twilightEmployees.splice(find, 1);
      });
      this.createResourceStatusForNotLoggedEmployees(this.twilightEmployees);
    });
  }

  createResourceStatusForNotLoggedEmployees(twilightEmployees) {
    let notLoggedEmployees = [];
    notLoggedEmployees = twilightEmployees;
    notLoggedEmployees.forEach(res => {
      let projectId = [];
      let resourceClass = this.parseService.instance.Object.extend('ResourceStatus');
      var resourceDetails = new resourceClass();
      resourceDetails.set('resourceStatus', 'Non-Billable');
      resourceDetails.set('user', { __type: 'Pointer', className: '_User', objectId: res.id });
      resourceDetails.set('projectId', projectId);
      resourceDetails.save();
    });
  }

  async createAbsentees() {
    this.toastr.success('Attendance generation started!!!');
    let startend = this.dateService.startEndDateByDate(new Date());
    let queryInstance = this.parseService.instance.Object.extend('UserTimeSheet');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('user');
    query.greaterThan('createdAt', startend[0]);
    query.lessThan('createdAt', startend[1]);
    query.limit(1000);
    let results = await query.find();
    let timesheet = JSON.parse(JSON.stringify(results));

    let twilightEmployees = [];
    let userInstance = this.parseService.instance.Object.extend('User');
    let userQuery = new this.parseService.instance.Query(userInstance);
    userQuery.include('profile');
    userQuery.include('profile.department');
    userQuery.include('profile.role');
    userQuery.include('profile.reportingTo');
    // Thiru                   
    // Murugan             
    // Admin Twilight            
    // Jaya divya
    userQuery.limit(10000000);
    userQuery.find().then(async results => {
      let userResult = results.filter(data => data.id != 'BIfNZHDTsc' && data.id != 'Hp5r6v7CwS' && data.id != 'NJt11DneE5' && data.id != 'VfbstJqMJw');
      twilightEmployees = userResult.filter(x => (x.get('profile').get('isActive') == true) && (x.get('profile').get('isLongLeave') == false));
      for (const element of timesheet) {
        let userId = element.user.objectId;
        let find = twilightEmployees.findIndex(x => x.id == userId);
        if (find != -1) {
          twilightEmployees.splice(find, 1);
        }
      }

      var deleteOldRecords = new this.parseService.instance.Query('Absentees');
      let dateDifferents = this.dateService.startEndDateByDate(new Date());
      deleteOldRecords.greaterThan('createdAt', dateDifferents[0]);
      deleteOldRecords.lessThan('createdAt', dateDifferents[1]);
      deleteOldRecords.limit(100000);
      let queryResult = await deleteOldRecords.find();
      if (queryResult.length > 0) {
        this.parseService.instance.Object.destroyAll(queryResult);
      }

      for (const res of twilightEmployees) {
        let absentClass = this.parseService.instance.Object.extend('Absentees');
        var absentClassCreate = new absentClass();
        absentClassCreate.set('absentDate', new Date());
        let datePipe = new DatePipe('en-US');
        let reportDate = datePipe.transform(new Date(), 'dd/MM/yyyy');
        absentClassCreate.set('reportDate', reportDate);
        absentClassCreate.set('user', { __type: 'Pointer', className: '_User', objectId: res.id });
        absentClassCreate.set('profile', { __type: 'Pointer', className: 'Profile', objectId: res.get('profile').id });
        absentClassCreate.set('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: res.get('profile').get('reportingTo').id });
        absentClassCreate.set('userName', res.get('profile').get('firstName') + ' ' + res.get('profile').get('lastName'));
        absentClassCreate.save();
      }
      this.toastr.success('Attendance generated!!!');
    });
  }

  employeeSelect(event) {

  }

  addEvent(event) {
    let date = new Date(this.dateConvertor.addGMTOffset(new Date(event.value)).toISOString());

    let startDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} 00:00:00.000`;
    let endDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} 23:59:59.000`;
    this.checkTime = date.getTime();

    this.query = `select * from DeviceLogs_${date.getMonth() + 1}_${date.getFullYear()} where LogDate > '${startDate}' and LogDate < '${endDate}' order by UserId desc`;

  }

}
